import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router";
//import App from './App';
import FindFactura from './Facturas/FindFactura';
import AddFactura from './Facturas/AddFactura';
import Login from './Login/Login';
import ViewFactura from './Facturas/FacturaView';
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Login />} />
        <Route path="/FindFactura" element={<FindFactura />} />
        <Route path="/AddFactura" element={<AddFactura />} />
        <Route path="/FacturaView/:uuid" element={<ViewFactura />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
